import React, { FC } from 'react'
import { Box, ThemeStyleObject } from '../../'

type CurlyDividerProps = {
    sx?: ThemeStyleObject
}

const curlyDividerSvg = 'https://assets.asktia.com/images/curly-divider.svg'

export const CurlyDivider: FC<React.PropsWithChildren<CurlyDividerProps>> = ({
    sx
}) => (
    <Box
        sx={{
            height: '6px',
            backgroundImage: `url(${curlyDividerSvg})`,
            backgroundRepeat: 'repeat-x',
            ...sx
        }}
    />
)
